import { useState } from "react";

export default function useModal(open?: boolean) {
  const [modalOpen, setOpen] = useState(!!open);
  return [modalOpen, setOpen] as const;
}
